<div class="min-vh-100 d-flex justify-content-center align-items-center bg-light">
  <div class="card shadow-lg p-4" style="max-width: 400px; width: 100%; border-radius: 1rem;">
    <div class="text-center mb-4">
      <h3 class="fw-bold text-success">Crear Cuenta</h3>
      <p class="text-muted small">Registrate para comenzar a usar TiendApp</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="registrar()">
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-user"></i>
          </span>
          <input
            type="text"
            id="nombre"
            class="form-control"
            formControlName="nombre"
            placeholder="Tu nombre completo"
            [class.is-invalid]="form.get('nombre')?.invalid && form.get('nombre')?.touched"
          />
          <div class="invalid-feedback">Nombre requerido</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="telefono" class="form-label">Teléfono</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-phone"></i>
          </span>
          <input
            type="text"
            id="telefono"
            class="form-control"
            formControlName="telefono"
            placeholder="Número de contacto"
            [class.is-invalid]="form.get('telefono')?.invalid && form.get('telefono')?.touched"
          />
          <div class="invalid-feedback">Teléfono requerido</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-envelope"></i>
          </span>
          <input
            type="email"
            id="email"
            class="form-control"
            formControlName="email"
            placeholder="ejemplo@correo.com"
            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
          />
          <div class="invalid-feedback">Email inválido</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="password" class="form-label">Contraseña</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-lock"></i>
          </span>
          <input
            type="password"
            id="password"
            class="form-control"
            formControlName="password"
            placeholder="Mínimo 6 caracteres"
            [class.is-invalid]="form.get('password')?.invalid && form.get('password')?.touched"
          />
          <div class="invalid-feedback">
            La contraseña debe tener al menos 6 caracteres
          </div>
        </div>
      </div>

      <div *ngIf="error" class="alert alert-danger small py-2">{{ error }}</div>

      <button
        type="submit"
        class="btn btn-success w-100 mb-3"
        [disabled]="form.invalid || loading"
      >
        {{ loading ? 'Creando...' : 'Crear cuenta' }}
      </button>

      <div class="text-center">
        <a style="cursor: pointer;" (click)="volverLogin()" class="small text-decoration-none">
          <i class="fa-solid fa-arrow-left"></i> ¿Ya tienes cuenta? Iniciar sesión
        </a>
      </div>
    </form>
  </div>
</div>
